"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskRecurring;
        (function (taskRecurring) {
            var edit;
            (function (edit) {
                function init() {
                    addEvents();
                    if ($('nav .navbar-nav-right button[value*="Delete"].btn-danger').length > 0) {
                        appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Delete"].btn-danger'), '#TaskRecurring_Name', undefined, undefined, false);
                        $('nav .navbar-nav-right button[value*="Delete"].btn-danger').attr('data-deletemessage', T('<b>Note:</b> Existing instances of the Recurring Task(s), if NOT already in-progress or completed, will be moved to Trash. You will have 30 days to restore from the Trash area before the data is permanently deleted from the system.'));
                    }
                }
                edit.init = init;
                function addEvents() {
                    $('#saveLink').on('click', function () {
                        $('form#appnForm').submit();
                    });
                }
            })(edit = taskRecurring.edit || (taskRecurring.edit = {}));
        })(taskRecurring = views.taskRecurring || (views.taskRecurring = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
